// 浏览器信息
// 
var ua = navigator.userAgent.toLowerCase(),
    info = {};


info.isAndroid = (/android/g).test(ua);
info.isIphone = (/ipod|iphone/g).test(ua);
info.isIos = (/ipad|iphone|mac/i).test(ua)
info.isAnChrome = (info.isAndroid && (/chrome/g).test(ua)) ? true : false;
info.isIosChrome = (info.isIos && (/crios/g).test(ua)) ? true : false;
info.isAnWx = (info.isAndroid && (/micromessenger/g).test(ua)) ? true : false;
info.isIpWx = (info.isIphone && (/micromessenger/g).test(ua)) ? true : false;
info.isSafari = false;

info.isWx = (/micromessenger/g).test(ua) ? true : false;
info.isWxWork = (/wxwork/g).test(ua) ? true : false;
info.isUc = ((/ucbrowser/g).test(ua)) ? true : false;
info.isQQBrowser = ((/qqbrowser/g).test(ua) && !info.isWx) ? true : false;
info.isQQ = (/qq\//i).test(ua) ? true : false;
info.isWeibo = (/weibo/g).test(ua) ? true : false;
info.isHuyaApp = (/huya/g).test(ua) ? true : false;
info.isIpad = (/ipad/g).test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ? true : false;
info.isAndroidPad = ((window.screen.width / window.devicePixelRatio >= 600) && info.isAndroid) ? true : false;

var version = /iphone os (\w+)/g.exec(ua);
info.iosVersionlargeThan8 = version ? (parseInt(version[1]) > 8) : false;


export default info;



// WEBPACK FOOTER //
// ./src/utils/device.js